export default {
  signalsNotFound: 'Folgende Signale wurden nicht gefunden: {signalNames}',
};
